import React from "react";
import ReactDOM from "react-dom";
import ReactGiphySearchbox from "react-giphy-searchbox";

import closeImg from "../../images/close-icon.png";

import "./ConversationStyleSheet.css";

const Popup = (props) => {
  return ReactDOM.createPortal(
    <div
      className="popup-box"
      style={{
        height: "500px",
        width: "97%",
        margin: "1% 2%",
        padding: 24,
        boxShadow: "1px 2px 18px 7px rgb(51 9 9 / 13%)",
        position: "relative",
        maxHeight: "400px",
        overflowY: "auto",
      }}
    >
      <div className="box">
        <div
          className="close-icon-gif"
          onClick={props.handleClose}
          style={{
            cursor: "pointer",
            position: "absolute",
            right: 8,
            top: 12,
          }}
        >
          <img
            src={closeImg}
            alt="close"
            style={{
              height: "8px",
              width: "8px",
              float: "left",
            }}
          ></img>
        </div>
        <ReactGiphySearchbox
          apiKey="your-api-key"
          masonryConfig={[
            { columns: 2, imageWidth: 110, gutter: 5 },
            { mq: "700px", columns: 3, imageWidth: 110, gutter: 5 },
          ]}
        />
      </div>
    </div>,
    document.getElementById("conver")
  );
};

export default Popup;
